import '.o{display:flex;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.e2{direction:ltr;}.ssr-plugin'
import '.cw{gap:48px;}.ssr-plugin'
import '.aw{text-align:center;}.ssr-plugin'
import '.f{flex:1;}.ssr-plugin'
import '.ap{position:relative;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.bb{justify-content:center;}.ssr-plugin'
import '.ay{overflow:hidden;}.ssr-plugin'
import '.cr{margin-bottom:24px;}.ssr-plugin'
import '.e3{padding-top:20px;}.ssr-plugin'
import '.e4{padding-bottom:8px;}.ssr-plugin'
import '.e5{min-height:240px;}.ssr-plugin'
import '.cq{border-radius:24px;}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.e6{backdrop-filter:blur(8px);}.ssr-plugin'
import '.e7{-webkit-backdrop-filter:blur(8px);}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.e8{font-family:Singing-Sans;}.ssr-plugin'
import '.e9{font-size:clamp(100px, 10vw, 144px);}.ssr-plugin'
import '.aq{display:block;}.ssr-plugin'
import '.ea{animation:esc-slide-out 0.35s cubic-bezier(0.22, 1, 0.36, 1) forwards;}.ssr-plugin'
import '.dc{word-break:break-word;}.ssr-plugin'
import '.eb{font-size:18px;}.ssr-plugin'
import '.ec{font-weight:900;}.ssr-plugin'
import '.ed{letter-spacing:0rem;}.ssr-plugin'
import { useState, useEffect, useRef } from 'react'
import { Style, styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { MOBILE, TABLET } from '../utils/breakpoints.js'
import { useDictionary } from '../hooks/useDictionary.js'

type CountdownTimerProps = {
  targetTimestamp: number
  dictionary?: any
  style?: Style
}

const formatTime = (ms: number) => {
  const totalSeconds = Math.floor(ms / 1000)
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  const pad = (n: number) => String(n).padStart(2, '0')
  return {
    Tdays: pad(days),
    Thours: pad(hours),
    Tminutes: pad(minutes),
    Tseconds: pad(seconds),
  }
}

export const CountdownTimer = ({
  targetTimestamp,
  style,
}: CountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState(() => {
    const remaining = targetTimestamp - Date.now()
    return remaining > 0 ? remaining : 0
  })

  const { days, hours, minutes, seconds } = useDictionary()

  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = targetTimestamp - Date.now()
      if (remaining <= 0) {
        setTimeLeft(0)
        clearInterval(interval)
      } else {
        setTimeLeft(remaining)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [targetTimestamp])

  const { Tdays, Thours, Tminutes, Tseconds } = formatTime(timeLeft)

  return (
    <styled.div className="o a e2 cw"
      style={{
        [TABLET]: { gap: '24px' },
        [MOBILE]: {
          gap: '8px',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr 1fr',
        },
        ...style,
      }}
    >
      <CountdownTimerElement numbers={Tdays} description={days} />
      <CountdownTimerElement numbers={Thours} description={hours} />
      <CountdownTimerElement numbers={Tminutes} description={minutes} />
      <CountdownTimerElement numbers={Tseconds} description={seconds} />
    </styled.div>
  )
}

type CountdownTimerElementProps = {
  numbers: string
  description: string | any
}

const CountdownTimerElement = ({
  numbers,
  description,
}: CountdownTimerElementProps) => {
  const prevRef = useRef({
    current: numbers,
    exiting: null as string | null,
    key: 0,
  })
  const [, setTick] = useState(0)

  const key =
    prevRef.current.current !== numbers
      ? prevRef.current.key + 1
      : prevRef.current.key

  const state = {
    current: numbers,
    exiting:
      prevRef.current.current !== numbers ? prevRef.current.current : null,
    key,
  }

  prevRef.current = { current: numbers, exiting: state.exiting, key }

  return (
    <div className="aw a f"
    >
      <styled.div className="ap o v bb ay cr e3 e4 e5 cq a ag e6 e7"
        style={{
          border: `1px solid ${colors.border}`,
          background: `linear-gradient(180deg, ${transparentColor(colors.white, 0)} 0%, ${transparentColor(colors.white, 0.1)} 50%, ${transparentColor(colors.white, 0)} 100%)`,
          [TABLET]: {
            minHeight: '96px',
          },
          [MOBILE]: {
            marginBottom: '8px',
          },
        }}
      >
        <style>{`
          @keyframes esc-slide-out {
            from { transform: translateY(0%);    opacity: 1; }
            to   { transform: translateY(-70%);  opacity: 0; }
          }
          @keyframes esc-slide-in {
            from { transform: translateY(70%);   opacity: 0; }
            to   { transform: translateY(0%);    opacity: 1; }
          }
        `}</style>
        {state.exiting !== null && (
          <styled.span className="a6 e8 e9 aq ea"
            key={`exit-${state.key}`}
            onAnimationEnd={() => {
              prevRef.current.exiting = null
              setTick((t) => t + 1)
            }}
            style={{
              color: colors.primary,
              [TABLET]: {
                fontSize: 'clamp(36px, 20vw, 72px)',
              },
              [MOBILE]: {
                fontSize: 'clamp(24px, 14vw, 64px)',
              },
            }}
          >
            {state.exiting}
          </styled.span>
        )}
        <styled.span className="e8 e9 aq"
          key={`enter-${state.key}`}
          style={{
            color: colors.primary,
            animation:
              state.key > 0
                ? 'esc-slide-in 0.35s cubic-bezier(0.22, 1, 0.36, 1) forwards'
                : 'none',
            [TABLET]: {
              fontSize: 'clamp(36px, 20vw, 72px)',
            },
            [MOBILE]: {
              fontSize: 'clamp(24px, 14vw, 64px)',
            },
          }}
        >
          {state.current}
        </styled.span>
      </styled.div>
      <styled.p className="dc a eb ec e8 ed"
        style={{
          [MOBILE]: {
            fontSize: '14px',
            fontWeight: '400',
            fontFamily: 'Neulis-Regular',
          },
        }}
      >
        {description}
      </styled.p>
    </div>
  )
}
